$(document).ready(function()
{

	var topAnchor = $($('div[id]')[0]).attr('id');
	//console.log(topAnchor);
	function updateLink()
	{

		//get current screen position
		var currentScrollPosition = $(window).scrollTop() + menuheight + 20;

		var myArray = [];
		myArray.push(0);
		
		internalLinks.each(function(index)
		{

			var theSection = $($(this).attr("href"));
			var divSectionPosition = theSection.offset();
			myArray.push(divSectionPosition.top);

		});

		//find out which section you are in
		var pos = 0;

		for (var i = 0; i < myArray.length; i = i + 1)
		{
			//console.log("i is: " + i + " " +  myArray[i]);
			if (currentScrollPosition > myArray[i])
			{
				pos = i;
				// console.log("currentScrollPosition " + currentScrollPosition + "> " + myArray[i] + " pos is: "  + pos);
			}
		}

		if (pos != posTracker)
		{

			posTracker = pos;
			//console.log("Updating position: " + pos);
			var browserUrl = getLinkName(pos - 1).substring(1);

			if (pos < myArray.length - 1)
			{
				$('a#arrowlink').attr("href", getLinkName(pos));
				$("#bottomarrow").removeClass("flip");

				if (pos == 0)
				{
					browserUrl = "medical";
				}
			}
			else
			{
				$("#bottomarrow").addClass("flip");
				$('a#arrowlink').attr("href", "#" + topAnchor);

			}
			//update browser url history.pushState('','', '/'+ browserUrl);
		}
	}



	function getLinkIndex(linkName)
	{
		//console.log("trying to find this: " + linkName);
		var theLinkIndex = 0;
		internalLinks.each(function(key, value)
		{
			//numInternalLinks = index;
			//console.log(key +" " + value + " " + $(this).attr("href") + " " + $(this).attr("href").substring(1));


			if (linkName == $(this).attr("href"))
			{
				theLinkIndex = key;
				//console.log("currentlink position is: " + key);
			}
		});

		return theLinkIndex;
	}



	function getLinkName(linkNum)
	{
		var theLinkName = "";

		internalLinks.each(function(key, value)
		{

			if (linkNum == key)
				theLinkName = $(this).attr("href");
		});

		//console.log("the link name to use is: " + theLinkName);

		return theLinkName;


	}



	function scroller(hash)
	{
		var animatecount = 0;

		//console.log("in scroller " + hash + " " + menuheight);

		if($(hash).offset() != null) {
			$('html,body').animate(
			{
				scrollTop: $(hash).offset().top - menuheight
			}, 500, function()
			{
				// Animation complete.

				//maxsection +=1;  //only use if section0 does not exist
				animatecount += 1;

				if (animatecount < 2)
				{
					updateLink();

				}

			}); //end animation
		}

	}



	if ($(".anchorrow [href]").length && $("#bottomarrow").length)
	{

		var $root = $('html, body');
		var menuheight = 0;
		var scrolltopOffset = 0;

		var internalLinks = $('.predip-inline-menu .anchorrow [href]').not(".nohash"),
		 internalLinksMobile = $('#navdrop2 .anchorrow [href]').not(".nohash"),
			numInternalLinks = internalLinks.length,
			numInternalLinksMobile = internalLinksMobile.length,
			currentActiveLink = 0,
			anchorLinks = $('.top_anchor');

		var posTracker = -1;

		if (numInternalLinks > 0)
		{
			//if internal links exist change them to local anchors.
			internalLinks.each(function(key, value)
			{
				//console.log(key +" " + value + " " + $(this).attr("href") + " " + $(this).attr("href").substring(1));
				if($(this).attr("class").indexOf("nohash") < 0)
				{
					//$(this).attr("href", "#" + this.pathname.substring(1).replace("/", ""));
					$(this).attr("href", "#" + $(anchorLinks[key]).attr('id'));
				}
			});
		}

		if (numInternalLinksMobile > 0)
		{
			//if internal links exist change them to local anchors.
			internalLinksMobile.each(function(key, value)
			{
				//console.log(key +" " + value + " " + $(this).attr("href") + " " + $(this).attr("href").substring(1));
				if($(this).attr("class").indexOf("nohash") < 0)
				{
					//$(this).attr("href", "#" + this.pathname.substring(1).replace("/", ""));
					$(this).attr("href", "#" + $(anchorLinks[key]).attr('id'));
				}
			});
		}

		$('a#arrowlink').attr("href", getLinkName(0));

		if ($(window).width() < 767) // || (bowser.mobile))
		{
			menuheight = 133;
			scrolltopOffset = menuheight + scrolltopOffset;
		}

		if (numInternalLinks < 1)
		{
			$("#bottomarrow").hide();
		}

		$('.anchorrow [href]').on('click', function(event)
		{
			if($(this).attr("class").indexOf("nohash") < 0)
			{
				event.preventDefault();
				scroller(this.hash);
			}

		}); //end arrowlink click

		$('a#arrowlink').on('click', function(event)
		{
			event.preventDefault();
			scroller(this.hash);
		});

		$(window).scroll(function()
		{
			setTimeout(function()
			{
				if (numInternalLinks > 0)
				{
					updateLink();
				}
			}, 100);
		});

	} // end anchor/arrow check

});